import React, {Component} from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import filestack from 'filestack-js';
import PropTypes from 'prop-types';

import 'scss/filestack_uploader.scss';

const {ContentType} = window.sn.enums;
class FilestackUploader extends Component {
    static defaultProps = {
        onFileSelected: R.identity,
        onFileUploadFinished: R.identity
    };

    constructor(props) {
        super(props);

        const {filestackApiKey} = this.props;

        this.client = filestack.init(filestackApiKey);
    }

    filestackOptions = () => {
        const {
            accept,
            maxFiles,
            maxSize,
            imageMin,
            storeTo,
            transformations,
            onFileUploadFailed,
            onFileSelected,
            onFileUploadFinished
        } = this.props;

        const defaultOptions = {
            fromSources: 'local_file_system',
            exposeOriginalFile: true,
            accept,
            maxFiles,
            maxSize,
            imageMin,
            storeTo,
            transformations,
            disableTransformer: R.isNil(transformations),
            onFileUploadFailed,
            onFileSelected,
            onFileUploadFinished
        };

        return R.pickBy(R.identity, defaultOptions);
    };

    handleFileUpload = async e => {
        e.preventDefault();
        const {disabled} = this.props;
        if (disabled) {
            return;
        }

        const options = this.filestackOptions();

        this.props.onFileConfirmedFinished(await this.client.pick(options));
    };

    displayButton = () => {
        const {uploadButtonText, uploadButtonClass, disabled} = this.props;
        const buttonClasses = uploadButtonClass
            ? classNames('btn', 'btn-primary', uploadButtonClass, {disabled})
            : null;

        return (
            <button className={buttonClasses} onClick={this.handleFileUpload}>
                {uploadButtonText}
            </button>
        );
    };

    displayUploadPrompt = () => {
        const {uploadButtonText, uploadButtonClass} = this.props;
        const buttonIcon = uploadButtonClass ? <i className={uploadButtonClass} /> : null;

        return (
            <div>
                {buttonIcon}
                <div>{uploadButtonText}</div>
            </div>
        );
    };

    displayUploadedContent = () => {
        const {contentType, uploadSrc, uploadPoster} = this.props;

        if (R.equals(contentType, ContentType.VIDEO)) {
            return <video src={uploadSrc} poster={uploadPoster} />;
        }

        if (R.equals(contentType, ContentType.IMAGE)) {
            return <img src={uploadSrc} role="presentation" />;
        }

        return null;
    };

    displayIcon = () => {
        const {uploadSrc} = this.props;
        const callToAction = uploadSrc ? this.displayUploadedContent() : this.displayUploadPrompt();

        return (
            <div className="icon-container text-center" onClick={this.handleFileUpload}>
                {callToAction}
            </div>
        );
    };

    displayCallToAction = () => {
        const {creatorDashboard} = this.props;
        return creatorDashboard ? this.displayIcon() : this.displayButton();
    };

    render() {
        const {disabled} = this.props;
        const callToAction = this.displayCallToAction();

        return (
            <div
                className="filestack-uploader-container"
                aria-disabled={disabled}
            >{callToAction}</div>
        );
    }
}

FilestackUploader.propTypes = {
    creatorDashboard: PropTypes.bool,
    contentType: PropTypes.string,
    disabled: PropTypes.bool,
    uploadButtonText: PropTypes.string.isRequired,
    uploadButtonClass: PropTypes.string,
    filestackApiKey: PropTypes.string.isRequired,
    accept: PropTypes.arrayOf(PropTypes.string.isRequired),
    maxFiles: PropTypes.number.isRequired,
    maxSize: PropTypes.number,
    imageMin: PropTypes.arrayOf(PropTypes.number),
    transformations: PropTypes.shape({
        rotate: PropTypes.bool,
        crop: PropTypes.shape({
            aspectRatio: PropTypes.number,
            force: PropTypes.bool
        })
    }),
    storeTo: PropTypes.shape({
        location: PropTypes.string,
        container: PropTypes.string,
        region: PropTypes.string,
        path: PropTypes.string
    }),
    onFileSelected: PropTypes.func,
    onFileUploadFinished: PropTypes.func,
    onFileUploadFailed: PropTypes.func.isRequired,
    onFileConfirmedFinished: PropTypes.func.isRequired,
    uploadSrc: PropTypes.string,
    uploadPoster: PropTypes.string
};

export default FilestackUploader;



// WEBPACK FOOTER //
// ./components/filestack_uploader.js